const userPointsRecommend = document.querySelector('.recommend-success')?.getAttribute('data-user-points')

interface ToastLink {
    href: string
    content: string
}

interface ToastItem {
    title: string
    text?: string
    icon: string
    status: 'success' | 'error' | 'info' | 'warning'
    links?: ToastLink[]
}

interface ToastParams {
    timer: number
    [key: string]: ToastItem | number
}

export const toastParams: ToastParams = {
  timer: 15000,
  visit_validate: {
    title: "Visite validée",
    text: "Votre dernière visite a bien été enregistrée. Un administrateur déclenchera vos points prochainement.",
    icon: "validate--fill",
    status: "success",
  },
  recommend_validate: {
    title: "Merci pour ce nouveau parrainage !",
    text: `Vous recevrez ${userPointsRecommend} points dans votre cagnotte dès que le conseiller sera entré en contact avec votre filleul.
        </br>Pour rappel si ce filleul passe commande, un JACKPOT de points vous sera crédité !`,
    icon: "validate--fill",
    status: "success",
  },
  testimonial_validate: {
    title: "Merci pour votre témoignage",
    text: "Pour compléter votre témoignage et gagner des points, il faut que vous ajoutiez une photo",
    icon: "validate--fill",
    status: "success",
  },
  testimonialStep_validate: {
    title: "Merci pour cette nouvelle action.",
    text: 'Un administrateur du site déclenchera prochainement vos points. Retrouvez le récapitulatif de vos points dans votre "Tableau de bord" ambassadeurs.',
    icon: "validate--fill",
    status: "success",
  },
  testimonial_images_success: {
    title: "Votre image a bien été téléchargée",
    icon: "validate--fill",
    status: "success",
  },
  testimonial_images_error: {
    title: "Les images doivent être de type jpg ou png",
    icon: "error--fill",
    status: "error",
  },
  error_testimonial: {
    title: "Votre témoignage doit faire au minimum 300 caractères",
    icon: "error--fill",
    status: "error",
  },
};
